import { useSelector } from 'react-redux';
import { Navigate } from "react-router-dom";

function PrivateRoute({ children, allowedRoles = [] }) { // Default allowedRoles to an empty array
  const isLoggedIn = useSelector((state) => state.auth?.isLoggedIn);
  const userRole = useSelector((state) => state.global.user?.role); // Get the user's role

  // Check if logged in
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  // Check if the user's role is one of the allowed roles, or if allowedRoles is empty (allow all authenticated users)
  const isRoleAllowed = allowedRoles.length === 0 || allowedRoles.includes(userRole);
  if (!isRoleAllowed) {
    // Redirect to an unauthorized page if the role is not allowed
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}

export default PrivateRoute;
